export const WardDetails = [//single data set which will consist Wards inventory details, drug consumptions etc
    {
      wardName: 'Cardiology',
      location: 'East Wing, 3rd Floor',
      headDoctor: 'Dr. Elizabeth Stone',
      logo: 'https://img.freepik.com/free-vector/high-blood-pressure-abstract-concept-illustration_335657-4603.jpg?ga=GA1.1.418411878.1733949512&semt=ais_hybrid',
      staff: [
        { name: 'Dr. John Doe', role: 'Cardiologist' },
        { name: 'Nurse Jane Smith', role: 'Nurse' },
        { name: 'Technician Mark Lee', role: 'Cardiac Technician' }
      ],
      inventory : [
        {
          name: 'Aspirin',
          stockLevel: 2,
          batchNumber: 'A123',
          expiryDate: new Date('2024-12-01').toLocaleDateString('en-GB'),
          ratePerUnit: 20,
          cost: 40,
          description: 'Aspirin is used to reduce fever, pain, and inflammation.',
          company: 'Bayer',
          tags: ['pain', 'fever', 'inflammation']
        },
        {
          name: 'Atorvastatin',
          stockLevel: 1,
          batchNumber: 'B456',
          expiryDate: new Date('2024-11-12').toLocaleDateString('en-GB'),
          ratePerUnit: 35,
          cost: 35,
          description: 'Atorvastatin is used to lower cholesterol and triglyceride levels in the blood.',
          company: 'Pfizer',
          tags: ['cholesterol', 'heart disease']
        },
        {
          name: 'Clopidogrel',
          stockLevel: 6,
          batchNumber: 'C789',
          expiryDate: new Date('2026-05-20').toLocaleDateString('en-GB'),
          ratePerUnit: 15,
          cost: 45,
          description: 'Clopidogrel is used to prevent blood clots, reducing the risk of stroke or heart attack.',
          company: 'Sanofi',
          tags: ['blood thinner', 'stroke', 'heart attack']
        },
        {
          name: 'Lisinopril',
          stockLevel: 0,
          batchNumber: 'D321',
          expiryDate: new Date('2025-07-01').toLocaleDateString('en-GB'),
          ratePerUnit: 18,
          cost: 0,
          description: 'Lisinopril is an ACE inhibitor used to treat high blood pressure and heart failure.',
          company: 'Merck',
          tags: ['blood pressure', 'heart failure']
        },
        {
          name: 'Furosemide',
          stockLevel: 1,
          batchNumber: 'E654',
          expiryDate: new Date('2026-09-25').toLocaleDateString('en-GB'),
          ratePerUnit: 10,
          cost: 10,
          description: 'Furosemide is a diuretic used to treat fluid retention and swelling caused by conditions like heart failure.',
          company: 'Lilly',
          tags: ['diuretic', 'fluid retention']
        },
        {
          name: 'Metoprolol',
          stockLevel: 4,
          batchNumber: 'F987',
          expiryDate: new Date('2025-12-10').toLocaleDateString('en-GB'),
          ratePerUnit: 25,
          cost: 50,
          description: 'Metoprolol is a beta-blocker used to treat high blood pressure and prevent heart attacks.',
          company: 'AstraZeneca',
          tags: ['blood pressure', 'heart attack prevention']
        },
        {
          name: 'Digoxin',
          stockLevel: 0,
          batchNumber: 'G123',
          expiryDate: new Date('2025-05-15').toLocaleDateString('en-GB'),
          ratePerUnit: 30,
          cost: 0,
          description: 'Digoxin is used to treat heart failure and atrial fibrillation.',
          company: 'Bristol-Myers Squibb',
          tags: ['heart failure', 'atrial fibrillation']
        },
        {
          name: 'Amlodipine',
          stockLevel: 15,
          batchNumber: 'H456',
          expiryDate: new Date('2026-03-20').toLocaleDateString('en-GB'),
          ratePerUnit: 22,
          cost: 22,
          description: 'Amlodipine is used to treat high blood pressure and chest pain (angina).',
          company: 'Pfizer',
          tags: ['blood pressure', 'angina']
        },
        {
          name: 'Heparin',
          stockLevel: 20,
          batchNumber: 'I789',
          expiryDate: new Date('2026-01-14').toLocaleDateString('en-GB'),
          ratePerUnit: 100,
          cost: 0,
          description: 'Heparin is an anticoagulant used to prevent blood clots.',
          company: 'Sanofi',
          tags: ['blood thinner', 'clot prevention']
        },
        {
          name: 'Warfarin',
          stockLevel: 0,
          batchNumber: 'J012',
          expiryDate: new Date('2026-04-05').toLocaleDateString('en-GB'),
          ratePerUnit: 50,
          cost: 50,
          description: 'Warfarin is used to prevent blood clots in the veins and arteries.',
          company: 'Bristol-Myers Squibb',
          tags: ['blood thinner', 'clot prevention']
        },
        {
          name: 'Nitroglycerin',
          stockLevel: 30,
          batchNumber: 'K345',
          expiryDate: new Date('2025-01-01').toLocaleDateString('en-GB'),
          ratePerUnit: 60,
          cost: 120,
          description: 'Nitroglycerin is used to prevent and treat chest pain (angina).',
          company: 'Novartis',
          tags: ['angina', 'chest pain']
        },
        {
          name: 'Statins',
          stockLevel: 18,
          batchNumber: 'L678',
          expiryDate: new Date('2026-07-20').toLocaleDateString('en-GB'),
          ratePerUnit: 40,
          cost: 160,
          description: 'Statins are used to lower cholesterol levels and reduce the risk of cardiovascular diseases.',
          company: 'AstraZeneca',
          tags: ['cholesterol', 'cardiovascular diseases']
        },
        {
          name: 'Dabigatran',
          stockLevel: 33,
          batchNumber: 'M901',
          expiryDate: new Date('2026-05-28').toLocaleDateString('en-GB'),
          ratePerUnit: 90,
          cost: 90,
          description: 'Dabigatran is an anticoagulant used to prevent blood clots and stroke in patients with atrial fibrillation.',
          company: 'Boehringer Ingelheim',
          tags: ['blood thinner', 'stroke prevention']
        }
      ],
      
      DrugConsumption : 
      [ 
        {
        
          "patientId": "P001",
          "patientName": "John Doe",
          "dob": "1985-06-15",
          "age": 39,
          "gender": "Male",
          "diagnosis": "Hypertension, High Cholesterol",
          "admissionDate": "2024-11-01",
          "dischargeDate": "2024-11-15",
          "medications": [
            {
              "medicationName": "Aspirin",
              "prescribedQuantity": 2,
              "consumedQuantity": 2,
              "issueQuantity": 2,
              "batchNumber": "A123",
              "expiryDate": "2026-06-12",
              "ratePerUnit": 20,
              "totalCost": 40,
              "medicationDescription": "Aspirin is used to reduce fever, pain, and inflammation.",
              "company": "Bayer",
              "tags": ["pain", "fever", "inflammation"],
              "shortage": true
            },
            {
              "medicationName": "Atorvastatin",
              "prescribedQuantity": 1,
              "consumedQuantity": 1,
              "issueQuantity": 1,
              "batchNumber": "B456",
              "expiryDate": "2025-08-15",
              "ratePerUnit": 35,
              "totalCost": 35,
              "medicationDescription": "Atorvastatin is used to lower cholesterol and triglyceride levels.",
              "company": "Pfizer",
              "tags": ["cholesterol", "heart disease"],
              "shortage": false
            },
            {
              "medicationName": "Metoprolol",
              "prescribedQuantity": 2,
              "consumedQuantity": 2,
              "issueQuantity": 2,
              "batchNumber": "F987",
              "expiryDate": "2025-12-10",
              "ratePerUnit": 25,
              "totalCost": 50,
              "medicationDescription": "Metoprolol is a beta-blocker used to treat high blood pressure.",
              "company": "AstraZeneca",
              "tags": ["blood pressure", "heart attack prevention"],
              "shortage": false
            }
          ]
        },
        
        {
          "patientId": "P002",
          "patientName": "Jane Smith",
          "dob": "1970-03-20",
          "age": 54,
          "gender": "Female",
          "diagnosis": "Heart Failure",
          "admissionDate": "2024-11-10",
          "dischargeDate": "2024-11-20",
          "medications": [
            {
              "medicationName": "Furosemide",
              "prescribedQuantity": 3,
              "consumedQuantity": 3,
              "issueQuantity": 1,
              "batchNumber": "E654",
              "expiryDate": "2026-09-25",
              "ratePerUnit": 10,
              "totalCost": 30,
              "medicationDescription": "Furosemide is a diuretic used to treat fluid retention and swelling.",
              "company": "Lilly",
              "tags": ["diuretic", "fluid retention"],
              "shortage": true
            },
            {
              "medicationName": "Lisinopril",
              "prescribedQuantity": 2,
              "consumedQuantity": 2,
              "issueQuantity": 0,
              "batchNumber": "D321",
              "expiryDate": "2025-07-01",
              "ratePerUnit": 18,
              "totalCost": 36,
              "medicationDescription": "Lisinopril is an ACE inhibitor used to treat high blood pressure.",
              "company": "Merck",
              "tags": ["blood pressure", "heart failure"],
              "shortage": true
            }
          ]
        },
        {
          "patientId": "P003",
          "patientName": "Alice Brown",
          "dob": "1992-09-05",
          "age": 32,
          "gender": "Female",
          "diagnosis": "Asthma",
          "admissionDate": "2024-11-05",
          "dischargeDate": "2024-11-20",
          "medications": [
            {
              "medicationName": "Albuterol",
              "prescribedQuantity": 4,
              "consumedQuantity": 4,
              "issueQuantity": 4,
              "batchNumber": "A123",
              "expiryDate": "2026-04-15",
              "ratePerUnit": 10,
              "totalCost": 40,
              "medicationDescription": "Albuterol is a bronchodilator used to relieve symptoms of asthma.",
              "company": "GlaxoSmithKline",
              "tags": ["asthma", "bronchodilator"],
              "shortage": false
            },
            {
              "medicationName": "Prednisone",
              "prescribedQuantity": 3,
              "consumedQuantity": 3,
              "issueQuantity": 3,
              "batchNumber": "B234",
              "expiryDate": "2025-12-01",
              "ratePerUnit": 5,
              "totalCost": 15,
              "medicationDescription": "Prednisone is a corticosteroid used to reduce inflammation.",
              "company": "Bristol-Myers",
              "tags": ["inflammation", "steroid"],
              "shortage": true
            }
          ]
        },
        
        // New patient P004 (Admitted on 2024-11-12, discharged on 2024-11-18)
        {
          "patientId": "P004",
          "patientName": "Robert Green",
          "dob": "1980-12-22",
          "age": 43,
          "gender": "Male",
          "diagnosis": "Diabetes",
          "admissionDate": "2024-10-12",
          "dischargeDate": "2024-10-18",
          "medications": [
            {
              "medicationName": "Metformin",
              "prescribedQuantity": 4,
              "consumedQuantity": 4,
              "issueQuantity": 4,
              "batchNumber": "C567",
              "expiryDate": "2025-09-30",
              "ratePerUnit": 15,
              "totalCost": 60,
              "medicationDescription": "Metformin is used to control blood sugar levels in type 2 diabetes.",
              "company": "Merck",
              "tags": ["diabetes", "blood sugar control"],
              "shortage": false
            }
          ]
        },
        {
          "patientId": "P005",
          "patientName": "Martha Black",
          "dob": "1965-04-10",
          "age": 59,
          "gender": "Female",
          "diagnosis": "Chronic Obstructive Pulmonary Disease (COPD)",
          "admissionDate": "2024-11-28",
          "dischargeDate": "2024-11-30",
          "medications": [
            {
              "medicationName": "Ipratropium",
              "prescribedQuantity": 2,
              "consumedQuantity": 2,
              "issueQuantity": 2,
              "batchNumber": "D890",
              "expiryDate": "2025-05-05",
              "ratePerUnit": 30,
              "totalCost": 60,
              "medicationDescription": "Ipratropium is an anticholinergic used to treat COPD symptoms.",
              "company": "Boehringer Ingelheim",
              "tags": ["COPD", "respiratory"],
              "shortage": false
            }
          ]
        },
        {
          "patientId": "P006",
          "patientName": "Liam Wilson",
          "dob": "2023-05-12",
          "age": 1,
          "gender": "Male",
          "diagnosis": "Bronchiolitis",
          "admissionDate": "2024-11-10",
          "dischargeDate": "2024-11-15",
          "medications": [
            {
              "medicationName": "Salbutamol",
              "prescribedQuantity": 3,
              "consumedQuantity": 3,
              "issueQuantity": 3,
              "batchNumber": "S123",
              "expiryDate": "2026-04-01",
              "ratePerUnit": 5,
              "totalCost": 15,
              "medicationDescription": "Salbutamol is a bronchodilator used for asthma and bronchiolitis.",
              "company": "GlaxoSmithKline",
              "tags": ["bronchiolitis", "asthma", "bronchodilator"],
              "shortage": false
            }
          ]
        },
        {
          "patientId": "P007",
          "patientName": "Emma Johnson",
          "dob": "2018-11-23",
          "age": 6,
          "gender": "Female",
          "diagnosis": "Asthma",
          "admissionDate": "2024-11-08",
          "dischargeDate": "2024-11-13",
          "medications": [
            {
              "medicationName": "Montelukast",
              "prescribedQuantity": 1,
              "consumedQuantity": 1,
              "issueQuantity": 1,
              "batchNumber": "M987",
              "expiryDate": "2025-10-20",
              "ratePerUnit": 10,
              "totalCost": 10,
              "medicationDescription": "Montelukast is used to prevent asthma attacks in children.",
              "company": "Merck",
              "tags": ["asthma", "preventative"],
              "shortage": false
            },
            {
              "medicationName": "Albuterol",
              "prescribedQuantity": 2,
              "consumedQuantity": 2,
              "issueQuantity": 2,
              "batchNumber": "A234",
              "expiryDate": "2026-02-15",
              "ratePerUnit": 6,
              "totalCost": 12,
              "medicationDescription": "Albuterol is a bronchodilator used to relieve asthma symptoms.",
              "company": "GlaxoSmithKline",
              "tags": ["asthma", "bronchodilator"],
              "shortage": false
            }
          ]
        },
        {
          "patientId": "P008",
          "patientName": "Noah Lee",
          "dob": "2010-07-18",
          "age": 14,
          "gender": "Male",
          "diagnosis": "Type 1 Diabetes",
          "admissionDate": "2024-11-05",
          "dischargeDate": "2024-11-10",
          "medications": [
            {
              "medicationName": "Insulin",
              "prescribedQuantity": 5,
              "consumedQuantity": 5,
              "issueQuantity": 5,
              "batchNumber": "I567",
              "expiryDate": "2025-11-30",
              "ratePerUnit": 50,
              "totalCost": 250,
              "medicationDescription": "Insulin is used to manage blood sugar levels in Type 1 Diabetes.",
              "company": "Novo Nordisk",
              "tags": ["diabetes", "insulin therapy"],
              "shortage": false
            },
            {
              "medicationName": "Metformin",
              "prescribedQuantity": 2,
              "consumedQuantity": 2,
              "issueQuantity": 2,
              "batchNumber": "M456",
              "expiryDate": "2025-08-12",
              "ratePerUnit": 20,
              "totalCost": 40,
              "medicationDescription": "Metformin helps control blood sugar levels in Type 2 Diabetes but can sometimes be prescribed for Type 1.",
              "company": "Merck",
              "tags": ["diabetes", "blood sugar control"],
              "shortage": false
            }
          ]
        }
        
      ]
    },
  ];

  